import type { Bank } from "@/apis/gql/types";

export const getAggregatedCapabilities = (bank: Bank) => {
  if (!bank) return null;

  const capabilities = {
    isPisSupported: false,
    isAisSupported: false,
    health: 0,
    aisCapabilities: {
      standingOrdersDownload: false,
      pendingTransactionsDownload: false,
    },
    paymentCapabilities: {
      sepaDirectDebit: false,
      sepaMoneyTransfer: false,
      sepaInstantMoneyTransfer: false,
      sepaCollectiveMoneyTransfer: false,
      sepaFutureDatedMoneyTransfer: false,
      sepaStandingOrder: false,
      domesticMoneyTransfer: false,
      domesticCollectiveMoneyTransfer: false,
      domesticFutureDatedMoneyTransfer: false,
    },
    aisAccountTypes: new Set(),
    loginHint: "",
  };

  capabilities.health = Math.max(
    ...bank.interfaces.map((iface) => iface.health || 0),
  );

  bank.interfaces.forEach((iface) => {
    capabilities.isPisSupported =
      capabilities.isPisSupported || iface.isPisSupported;
    capabilities.isAisSupported =
      capabilities.isAisSupported || iface.isAisSupported;

    if (iface.aisCapabilities) {
      capabilities.aisCapabilities.standingOrdersDownload =
        capabilities.aisCapabilities.standingOrdersDownload ||
        iface.aisCapabilities.standingOrdersDownload;
      capabilities.aisCapabilities.pendingTransactionsDownload =
        capabilities.aisCapabilities.pendingTransactionsDownload ||
        iface.aisCapabilities.pendingTransactionsDownload;
    }

    if (iface.paymentCapabilities) {
      (
        Object.keys(iface.paymentCapabilities) as Array<
          keyof typeof capabilities.paymentCapabilities
        >
      ).forEach((key) => {
        capabilities.paymentCapabilities[key] = Boolean(
          capabilities.paymentCapabilities[key] ||
            iface.paymentCapabilities[key],
        );
      });
    }

    if (iface.aisAccountTypes) {
      iface.aisAccountTypes.forEach((type) =>
        capabilities.aisAccountTypes.add(type),
      );
    }

    if (
      iface.loginHint &&
      (!capabilities.loginHint ||
        iface.loginHint.length > capabilities.loginHint.length)
    ) {
      capabilities.loginHint = iface.loginHint;
    }
  });

  return capabilities;
};

export const getBankInitials = (name: string) => {
  return name.slice(0, 2);
};
